// extracted by mini-css-extract-plugin
export default {"column":"ReportFilter_column__ovE3i","placeHolderShimmer":"ReportFilter_placeHolderShimmer__Nl2-H"};